import React, { useState } from "react";
import AdmissionForm from "./components/AdmissionForm/AdmissionForm";
import FeeReceipt from "./components/FeeReceipt/FeeReceipt";
import "./App.css";
import "./nav.css";

function App() {
  const [view, setView] = useState("admission");

  return (
    <div className="App">
      <nav className="app-nav">
        <button
          className={`app-nav-btn ${view === "admission" ? "active" : ""}`}
          onClick={() => setView("admission")}
        >
          Admission Form
        </button>
        <button
          className={`app-nav-btn ${view === "fee" ? "active" : ""}`}
          onClick={() => setView("fee")}
        >
          Fee Receipt
        </button>
      </nav>

      {view === "admission" ? <AdmissionForm /> : <FeeReceipt />}
    </div>
  );
}

export default App;